<div class="margin__t">
    <h3 class="txt-c">404 Page Not Found</h3>
    <div class="txt-c" (click)="redirect_home()">
      <ion-button fill="clear">Go Back Home</ion-button>
    </div>
</div>
